var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mine_title flex justify_between align_center"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"page"},[_vm._v(_vm._s(_vm.page))])])}
var staticRenderFns = []

export { render, staticRenderFns }